import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logowhite from "../../assets/logowhite.png";
import Loading from "../../common/Laoding";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import toast from "react-hot-toast";

const Changepassword = () => {
  const navigate = useNavigate();
  const tokenForChangepwd = localStorage.getItem("token");
  const userId = JSON.parse(localStorage.getItem("profile"))?.id;
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [showOldPwd, setShowOldPwd] = useState(false);
  const [showNewPwd, setShowNewPwd] = useState(false);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let newErrors = {};

    // Old Password
    if (!oldPassword.trim()) {
      newErrors.oldPassword = "Old password is required";
    }

    // New Password
    if (!newPassword.trim()) {
      newErrors.newPassword = "New password is required";
    } else {
      if (newPassword.length < 8)
        newErrors.newPassword = "Password must be minimum 8 characters";

      if (!/[A-Z]/.test(newPassword))
        newErrors.newPassword = "Must contain at least 1 uppercase letter";

      if (!/[a-z]/.test(newPassword))
        newErrors.newPassword = "Must contain at least 1 lowercase letter";

      if (!/[0-9]/.test(newPassword))
        newErrors.newPassword = "Must contain at least 1 number";

      if (!/[!@#$%^&*(),.?":{}|<>]/.test(newPassword))
        newErrors.newPassword = "Must contain at least 1 special character";

      if (oldPassword && newPassword === oldPassword)
        newErrors.newPassword = "New password cannot be same as old password";
    }

    // OTP
    if (!otp.trim()) {
      newErrors.otp = "OTP is required";
    } else if (!/^\d{6}$/.test(otp)) {
      newErrors.otp = "OTP must be a 6-digit number";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const generatePasswordChangeRequest = async () => {
    // e.preventDefault();
    try {
      const response = await fetch(
        `${apiUrl}/api/v1/users/generatechangepwdrequest`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: tokenForChangepwd,
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
      }
      return data;
    } catch (error) {
      return console.error("Error fetching generatechangepwdrequest:", error);
    }
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      const response = await fetch(`${apiUrl}/api/users`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: tokenForChangepwd,
        },
        body: JSON.stringify({
          id: userId,
          oldPassword: oldPassword,
          newPassword: newPassword,
          changePassword: true,
          otp : otp
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        localStorage.removeItem("profile");
        localStorage.removeItem("token");
        localStorage.removeItem("rememberedEmail");
        localStorage.removeItem("status");
        navigate("/");
      } else {
        toast.error(data?.msg, {
          position: "bottom-center",
          style: {
            background: "white", // override background
            color: "red",
            fontWeight: "medium",
            marginBottom: "20px",
          },
        });
      }
      return data;
    } catch (error) {
      return console.error("Error fetching user change password:", error);
    }
  };

  useEffect(() => {
    if (tokenForChangepwd) {
      generatePasswordChangeRequest();
    }
  }, [tokenForChangepwd]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="bg-white/20 max-w-md mx-auto backdrop-blur-sm p-8 rounded-xl shadow-md w-full mt-10 md:mt-0">
        <img className="w-[150px] mb-4 mx-auto" src={logowhite} alt="Logo" />
        <h1 className="text-center text-white my-6 font-bold text-2xl">
          Change Your Password
        </h1>
        

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <div className="relative">
              <label className="text-white font-medium mb-1 block">
                Old Password
              </label>

              <input
                type={showOldPwd ? "text" : "password"}
                className="w-full p-3 rounded-lg focus:outline-none"
                placeholder="Enter old password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                required
              />

              <button
                type="button"
                onClick={() => setShowOldPwd((prev) => !prev)}
                className="absolute right-4 top-[65%] -translate-y-1/2 text-gray-600"
              >
                {showOldPwd ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </button>
            </div>
            {errors.oldPassword && (
              <p className="text-red-500 text-sm mt-1">{errors.oldPassword}</p>
            )}
          </div>

          <div>
            <div className="relative">
              <label className="text-white font-medium mb-1 block">
                New Password
              </label>

              <input
                type={showNewPwd ? "text" : "password"}
                className="w-full p-3 rounded-lg focus:outline-none"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />

              <button
                type="button"
                onClick={() => setShowNewPwd((prev) => !prev)}
                className="absolute right-4 top-[65%] -translate-y-1/2 text-gray-600"
              >
                {showNewPwd ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </button>
            </div>
            {errors.newPassword && (
              <p className="text-red-500 text-sm mt-1">{errors.newPassword}</p>
            )}
          </div>

          <div>
            <label className="text-white font-medium mb-1 block">
              Enter OTP
            </label>
            <input
              type="text"
              className="w-full p-3 rounded-lg focus:outline-none"
              placeholder="Enter OTP"
              value={otp}
              maxLength={6}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
            {errors.otp && (
              <p className="text-red-500 text-sm mt-1">{errors.otp}</p>
            )}
          </div>

          <button
            type="submit"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded-full transition duration-300"
          >
            Submit
          </button>
        </form>

        <button
          onClick={() => navigate("/")}
          className="mt-4 w-full text-white font-semibold py-2 rounded-full transition duration-300"
        >
          Move to Login-In
        </button>
      </div>
    </div>
  );
};

export default Changepassword;
